'use client';

import { useCallback } from 'react';
import { useXpConfig as useXpConfigQuery } from '../queries/useProfileQueries';

export const useXpConfig = () => {
  const { data: config, isLoading: loading, error, refetch } = useXpConfigQuery();

  const calculateDepositXp = useCallback((creditsAmount: number): number => {
    if (!config || creditsAmount <= 0) return 0;

    const rubAmount = creditsAmount / 250;
    const baseXp = Math.floor((rubAmount / 100) * 5);

    const multiplierEntry = config.depositMultipliers.find((m) => creditsAmount >= m.minCredits);
    const multiplier = multiplierEntry?.multiplier || 1.0;

    return Math.floor(baseXp * multiplier);
  }, [config]);

  const getReferralInviteXp = useCallback((): number => {
    return config?.rewards.referralInvite ?? 0;
  }, [config]);

  const getReferralDepositXp = useCallback((): number => {
    return config?.rewards.referralDeposit ?? 0;
  }, [config]);

  return {
    config: config ?? null,
    loading,
    error: !!error,
    refetch: () => { refetch(); },
    calculateDepositXp,
    getReferralInviteXp,
    getReferralDepositXp,
    rewards: config?.rewards ?? null,
    depositMultipliers: config?.depositMultipliers ?? [],
  };
};
